/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { useTranslation } from 'react-i18next';
import { Icon } from './Icon';
import { Title } from './Title';

const ChangeEmailSuccess = () => {
  const { t } = useTranslation();

  return (
    <>
      <Icon type={'successBlue'} />
      <Title>{t('NOTIFICATION_CHANGE_EMAIL_SUCCESS_MODAL__title')}</Title>
    </>
  );
};

export { ChangeEmailSuccess };
